import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private messageService = inject(MessageService);
    private requestsInProgress = 0;
    private loading = new BehaviorSubject<boolean>(false);
    private toastQueue: Parameters<MessageService['add']>[0][] = [];

    isLoading$ = this.loading.asObservable();

    show() {
        this.requestsInProgress++;
        if (this.requestsInProgress === 1) {
            this.loading.next(true);
        }
    }

    hide() {
        if (this.requestsInProgress > 0) {
            this.requestsInProgress--;
        }
        if (this.requestsInProgress === 0) {
            this.loading.next(false);
            this.flushToasts();
        }
    }

    queueToast(config: Parameters<MessageService['add']>[0]) {
        this.toastQueue.push(config);
    }

    private flushToasts() {
        const toasts = this.toastQueue.splice(0);
        toasts.forEach(toast => this.messageService.add(toast));
    }
}
